define('viewmodels/pages/reelRaces/reelRaces',[
    'knockout',
    'underscore'
], function (ko, _) {

    function ReelRacesViewModel (playerTabs,
                                genericReelRacesTermsFieldFetcher,
                                reelRacesFieldFetcher,
                                gamesInterface,
                                tournamentCampaignsViewModel,
                                ReelRacesHowItWorksDialog,
                                dialog) {

        var self = this,
            SCHEDULE_TAB_ID = 'schedule',
            PREVIOUS_WINNERS_TAB_ID = 'previousWinners',
            tournamentCampaign = tournamentCampaignsViewModel.activeCampaign(),
            gamesSlugs = tournamentCampaign.recommendedGames;

        self.tournamentCampaign = tournamentCampaign;
        self.subNav = playerTabs;
        self.meta = {
            title: reelRacesFieldFetcher('meta_title'),
            description: reelRacesFieldFetcher('meta_description')
        };

        _.assign(self, tournamentCampaign);

        self.tabs = [
            {
                id: SCHEDULE_TAB_ID,
                title: tournamentCampaign.scheduleTabTitle
            },
            {
                id: PREVIOUS_WINNERS_TAB_ID,
                title: tournamentCampaign.previousWinnersTabTitle
            }
        ];

        self.selectedTabId = ko.observable(_.first(self.tabs).id);

        self.activate = function () {
            self.selectTab(SCHEDULE_TAB_ID);
        };

        self.selectTab = function (id) {
            if (this.selectedTabId() === id) {
                return;
            }
            this.selectedTabId(id);
        };

        self.showHowItWorksDialog = function () {
            dialog.showDialog(new ReelRacesHowItWorksDialog());
        };

        self.recommendedGames = gamesInterface.findVisibleBySlugs(gamesSlugs);

        self.compositionComplete = function () {
            var previousTournaments = self.previousTournaments();

            if (previousTournaments.length) {
                previousTournaments[0].showDetailedView(true);
            }
        };

    }

    return ReelRacesViewModel;
});

